export const ASSIGN_BULK_CUTOMER_INIT_ACTION = "ASSIGN_BULK_CUTOMER_INIT_ACTION";
export const ASSIGN_BULK_CUTOMER_SUCCESS_ACTION = ASSIGN_BULK_CUTOMER_INIT_ACTION + "_SUCCESS";
export const ASSIGN_BULK_CUTOMER_FAIL_ACTION = ASSIGN_BULK_CUTOMER_INIT_ACTION + "_ERROR";

export const CLEAR_BULK_ASSIGN_REPORT_INIT_ACTION = 'CLEAR_BULK_ASSIGN_REPORT_INIT_ACTION';